module.exports = __webpack_public_path__ + "img/phone.420de71c.svg";